import { render, staticRenderFns } from "./VesselOverviewCard.vue?vue&type=template&id=6be29b1a&scoped=true&"
import script from "./VesselOverviewCard.vue?vue&type=script&lang=js&"
export * from "./VesselOverviewCard.vue?vue&type=script&lang=js&"
import style0 from "./VesselOverviewCard.vue?vue&type=style&index=0&id=6be29b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be29b1a",
  null
  
)

export default component.exports